import Footer from './src/footer';

Footer.install = function(Vue) {
  Vue.component(Footer.name, Footer);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js